/* Sae — Set Builder. Colour swatches + size buttons per component, colour-linked
   thumbnail. Add button stays disabled until every component has a colour + size
   (single-value options auto-select). "Add set" adds the real variants
   in one cart request with _set line properties, then opens the cart. */
(function () {
  'use strict';

  var root = document.querySelector('[data-set-builder]');
  if (!root) return;

  var setHandle = root.getAttribute('data-set-handle');
  var setName = root.getAttribute('data-set-name');
  var setTotal = root.getAttribute('data-set-total') || '';
  var setCount = root.getAttribute('data-set-count') || '';
  var addBtn = root.querySelector('[data-setb-add]');
  var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-setb-msg]'));
  var msg = msgs.length ? msgs[msgs.length - 1] : null;
  var root_url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  // Paint each colour dot as a solid fill sampled from its swatch tile — a clean
  // circle in the true product colour (tiles are accurate; swatch.color isn't always).
  (function solidifyDots() {
    root.querySelectorAll('.setb__dot[data-tile]').forEach(function (dot) {
      var url = dot.getAttribute('data-tile');
      if (!url) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = 8; c.height = 8;
          var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, 8, 8);
          var d = ctx.getImageData(4, 4, 1, 1).data;
          dot.style.backgroundColor = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
          dot.style.backgroundImage = 'none';
        } catch (e) { /* keep the tile image as fallback */ }
      };
      img.src = url;
    });
  })();

  function showMsg(text, isError) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('setb__msg--error', !!isError);
  }

  var comps = Array.prototype.slice.call(root.querySelectorAll('[data-component]')).map(function (el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-component-data]').textContent); }
    catch (e) { data = { single: true, variants: [] }; }
    return {
      el: el, data: data,
      thumb: el.querySelector('[data-setb-thumb]'),
      colorName: el.querySelector('[data-setb-color-name]'),
      swatches: Array.prototype.slice.call(el.querySelectorAll('.setb__swatch')),
      sizes: Array.prototype.slice.call(el.querySelectorAll('.setb__size')),
      color: null, size: null
    };
  });

  function refreshSizes(c) {
    if (c.data.single || !c.sizes.length) return;
    c.sizes.forEach(function (btn) {
      var size = btn.getAttribute('data-size');
      var ok = c.data.variants.some(function (v) {
        return (!c.color || v['o' + c.data.colorPos] === c.color) && v['o' + c.data.sizePos] === size && v.available;
      });
      btn.disabled = !ok;
    });
    var cur = c.sizes.find(function (b) { return b.getAttribute('data-size') === c.size; });
    if (cur && cur.disabled) selectSize(c, null);
  }

  function selectSize(c, btn) {
    c.sizes.forEach(function (b) { b.classList.remove('is-selected'); });
    if (btn) { btn.classList.add('is-selected'); c.size = btn.getAttribute('data-size'); }
    else { c.size = null; }
  }

  function selectColor(c, btn) {
    c.swatches.forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    c.color = btn.getAttribute('data-color');
    if (c.thumb && btn.getAttribute('data-image')) c.thumb.src = btn.getAttribute('data-image');
    if (c.colorName) c.colorName.textContent = btn.getAttribute('data-color-name') || '';
    refreshSizes(c);
  }

  function resolvedVariant(c) {
    if (c.data.single) return c.data.variants[0] || { id: c.data.defaultId, available: true };
    if (!c.color || !c.size) return null;
    return c.data.variants.find(function (v) {
      return v['o' + c.data.colorPos] === c.color && v['o' + c.data.sizePos] === c.size;
    });
  }

  function isComplete(c) { var v = resolvedVariant(c); return !!(v && v.available !== false); }

  function updateButton() { if (addBtn) addBtn.disabled = !comps.every(isComplete); }

  comps.forEach(function (c) {
    if (c.data.single) return;
    c.swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { selectColor(c, btn); showMsg(''); updateButton(); });
    });
    c.sizes.forEach(function (btn) {
      btn.addEventListener('click', function () { if (!btn.disabled) { selectSize(c, btn); showMsg(''); updateButton(); } });
    });
    // show the first colour (circled + its variant image); leave size unchosen
    // so the Add button stays disabled until the customer picks each size.
    if (c.swatches.length) selectColor(c, c.swatches[0]);
    if (c.sizes.length === 1 && !c.sizes[0].disabled) selectSize(c, c.sizes[0]);
  });
  updateButton();

  // Add all component variants in a single /cart/add.js request. The items form
  // is atomic — if any piece is unavailable, nothing is added — and far faster
  // than one round-trip per component.
  function addItems(items) {
    return fetch(root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }

  if (addBtn) addBtn.addEventListener('click', function () {
    if (addBtn.disabled) return;
    showMsg('');
    var setId = setHandle + '-' + Date.now();
    var items = [];
    for (var i = 0; i < comps.length; i++) {
      var v = resolvedVariant(comps[i]);
      if (!v || v.available === false) { updateButton(); return; }
      items.push({ id: v.id, quantity: 1, properties: { _set: setHandle, _set_name: setName, _set_id: setId, _set_total: setTotal, _set_count: setCount } });
    }
    addBtn.disabled = true;
    var label = addBtn.querySelector('[data-setb-add-label]');
    if (label) label.textContent = 'Adding…';
    addItems(items)
      .then(function () { window.location.href = root_url + 'cart'; })
      .catch(function (err) {
        addBtn.disabled = false;
        if (label) label.textContent = 'Add set to cart';
        showMsg((err && err.description) || 'Something went wrong adding the set. Please try again.', true);
      });
  });
})();
